import Helper from "../../Helper";
import { Dropoff } from "../../models/Dropoff";
import { MapObject } from "../../models/MapObject";
import { plotFetch } from "../Helper/ApiRequest";

export function getProjectDropoffs(
    team_subdomain: string,
    project_token: string,
    timezone: string,
    archived: boolean = false
): Promise<Dropoff[]> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/dropoffs?archived=${archived}`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((dropoff: any) => Dropoff.fromApiObject(dropoff, timezone));
        })
        .catch((error) => {
            return [];
        });
}

export function getDropoffAttachments(
    team_subdomain: string,
    project_token: string,
    dropoff_id: number
): Promise<any[]> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/dropoffs/${dropoff_id}/dropoffs_attachments`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .catch((error) => {
            return [];
        });
}

export function deleteDropoff(team_subdomain: string, project_token: string, dropoff: Dropoff): Promise<boolean> {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain)}/projects/${project_token}/dropoffs/${dropoff.id}`,
        { method: "DELETE" },
        true
    )
        .then((response) => {
            if (response.ok) {
                return true;
            }
            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}

export function createDropoff(
    team_subdomain: string,
    project_token: string,
    dropoff: Dropoff,
    map_object: MapObject,
    tagged_teams: number[],
    timezone: string
): Promise<Dropoff | null> {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain)}/projects/${project_token}/dropoffs`,
        {
            method: "POST",
            body: JSON.stringify({
                dropoff: dropoff.toApiObject(),
                map_object: map_object.toApiObject(),
                tagged_teams: tagged_teams,
            }),
        },
        true
    )
        .then(async (data) => {
            const jsonData = await data.json();
            if (!data.ok) {
                const errorMessage = jsonData.error || data.statusText;
                throw new Error(errorMessage);
            }
            return jsonData;
        })
        .then((data) => {
            return Dropoff.fromApiObject(data, timezone);
        })
        .catch(() => {
            return null;
        });
}

export function updateDropoff(
    team_subdomain: string,
    project_token: string,
    dropoff: Dropoff,
    tagged_teams: number[],
    timezone: string
): Promise<Dropoff | null> {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain)}/projects/${project_token}/dropoffs/${dropoff.id}`,
        {
            method: "PUT",
            body: JSON.stringify({ dropoff: dropoff.toApiObject(), tagged_teams: tagged_teams }),
        },
        true
    )
        .then((data) => {
            if (data.ok) {
                return data.json();
            }
            throw new Error("Network error.");
        })
        .then((data) => {
            return Dropoff.fromApiObject(data, timezone);
        })
        .catch(() => {
            return null;
        });
}

// Sends only banned_vehicles, so saving the vehicle switches doesn't also save other unsaved edits to the location.
export function updateDropoffBannedVehicles(
    team_subdomain: string,
    projectToken: string,
    id: number,
    bannedVehicles: string[]
): Promise<boolean> {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${projectToken}/dropoffs/${id}`,
        {
            method: "PUT",
            body: JSON.stringify({ dropoff: { banned_vehicles: bannedVehicles } }),
        }
    )
        .then((response) => response.ok)
        .catch(() => false);
}
